module.exports = __webpack_public_path__ + "static/media/slider-left-white.958ce7d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/slider-left-white.svg
// module id = 67
// module chunks = 0